module.exports = __webpack_public_path__ + "static/media/eveningEps.115acbe3.svg";